 /**
 * Setup: add the below script include to pages that have a checkout button
 * 
 * <script src="{{ 'skio-volume-discount.js' | asset_url }}" defer="defer"></script>
 * 
 * Make sure the selector below covers all checkout buttons
 */

document.addEventListener('DOMContentLoaded', async function () {
  
  const { rules } = await (await fetch(`https://api.skio.com/storefront-http/get-rules-by-domain-or-hostname?domain=${window?.Shopify?.shop}`)).json();
  
  async function applyVolumeDiscount () {
    const cart = await (await fetch('/cart.js')).json()
  
    // Check each rule to find the eligible rule 
    // with the largest min quantity
    let largestMinQuantity = {
      value: -1,
      index: -1,
    }
    
    rules.forEach((rule, index) => {
      if (rule.code &&
          largestMinQuantity.value < rule.minQuantityToDiscount
      ) {
        // Gets the count of eligible items in the cart for this rule
        const eligibleCount = cart.items.reduce(
          (aggregate, item) => rule.productVariantIds.some(gid => gid.includes(item.id)) ? 
              aggregate + item.quantity : aggregate 
          , 0)
        if (rule.minQuantityToDiscount <= eligibleCount) {
          largestMinQuantity.value = rule.minQuantityToDiscount
          largestMinQuantity.index = index
        }
      }
    })
  
    const rule = largestMinQuantity.index > -1 ? rules[largestMinQuantity.index] : null
    
    // Apply code
    if (rule && rule.code !== window.skio_applied_rule_code) {
      await fetch(`/discount/${rule.code}`)
      window.skio_applied_rule_code = rule.code;
      window.upcartRefreshCart && window.upcartRefreshCart()
    }
  }
  
  window.upcartOnCartOpened = () => {
    const event = new CustomEvent(`upcart::cart-opened`, {
      bubbles: true,
      composed: true,
    });
    document.dispatchEvent(event);
  }
  
  window.upcartOnCartUpdated = () => {
    const event = new CustomEvent(`upcart::cart-updated`, {
      bubbles: true,
      composed: true,
    });
    document.dispatchEvent(event);
  }
  
  document.addEventListener('upcart::cart-opened', () => {
    applyVolumeDiscount();
  });
  document.addEventListener('upcart::cart-updated', () => {
    applyVolumeDiscount();
  });
})